import { FamiliarInfo, PosibleFamiliar } from '../api';
import FamiliarChip from './FamiliarChip';

// FAMILIA EN EL PERFIL (23-sep-2026). Solo se LEE aquí: cada familiar con su avatar y un tooltip (estado, plan,
// clases, mensualidad, ir al perfil). Registrar, quitar o confirmar una posible familia se hace en la pestaña
// «Familia» (Carlos: «donde dice registrar familiar o quitar de la familia directamente me mande a esta nueva
// pestaña»). La familia confirmada alimenta la revisión mensual de descuentos (lib/letsmoveFamilia.js).
export default function FamiliaFicha({ familia, posible, puedeEditar, onGestionar }: {
  familia: FamiliarInfo[];
  posible: PosibleFamiliar[];
  puedeEditar: boolean;
  onGestionar: () => void;
}) {
  if (!familia.length && !posible.length && !puedeEditar) return null;
  return (
    <div className="mt-2 space-y-1.5 text-xs text-content-3" data-testid="familia-ficha">
      {familia.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5">
          <span>👪 <b className="text-content">Familia:</b></span>
          {familia.map((f) => <FamiliarChip key={f.contact_id} f={f} />)}
        </div>
      )}
      {posible.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5" data-testid="posible-familia">
          <span>👪 Posible familia:</span>
          {posible.map((f) => <FamiliarChip key={f.contact_id} f={f} extra={<span className="font-normal text-content-3">({f.razones.join(' y ')})</span>} />)}
        </div>
      )}
      {puedeEditar && (
        <button type="button" onClick={onGestionar} data-testid="ir-familia" className="text-brand-blue hover:underline">
          {familia.length ? 'Gestionar familia y descuento →' : posible.length ? 'Confirmar o registrar familia →' : '+ registrar familiar →'}
        </button>
      )}
    </div>
  );
}
